export const openPdf = (url) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const formatDate = (date) =>
  date instanceof Date ? date.toLocaleDateString('en-US') : '';

export const formatTime = (date) =>
  date instanceof Date
    ? date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })
    : '';
